import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../services/api';

const STORAGE_KEY = 'zxdata.anonymousRedemptions.v1';
const DONE_KEY = 'zxdata.attributeDone.v1';

/**
 * 登录态下，把本浏览器 localStorage 里的匿名兑换 token 回传后端做「匿名 -> 邮箱」归因。
 * 只记录、不转移权益；接口幂等；失败静默（不打扰用户）。
 * 触发：isAuthenticated 变真时执行一次；同一 token 集合本会话只提交一次。
 */
export function useAttributeAnonymous() {
  const { isAuthenticated } = useAuth();
  useEffect(() => {
    if (!isAuthenticated) return;
    let tokens: string[] = [];
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw) as Record<string, { token?: string }>;
        tokens = Object.values(parsed || {})
          .map((r) => r?.token)
          .filter((t): t is string => typeof t === 'string' && /^[a-f0-9]{64}$/i.test(t));
      }
    } catch {
      /* localStorage 解析失败：忽略 */
    }
    tokens = [...new Set(tokens)];
    if (!tokens.length) return;
    const sig = tokens.slice().sort().join(',');
    if (sessionStorage.getItem(DONE_KEY) === sig) return;
    api
      .post('/redemptions/attribute-anonymous', { tokens })
      .then(() => sessionStorage.setItem(DONE_KEY, sig))
      .catch(() => {
        /* 归因失败不影响主流程，静默 */
      });
  }, [isAuthenticated]);
}
